
// SVG Icon: loader
export default { id: "terriajs-loader" };
export const id = "terriajs-loader";
export const name = "loader";
